import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { loadDealers, loadContactModes } from "../../actionCreators";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import DescriptionIcon from "@mui/icons-material/Description";
import { Grid } from "@mui/material";
import { CollapseCard } from "@totalsoft/rocket-ui";
import DealerListComponent from "./DealerListComponent";
import { getDealers, getContactModes } from "../../selectors";
import { withParams } from "../../../../providers/ParamsConsumer";
import { useReactiveVar } from "@apollo/client";
import { synchronizationInProgressVar } from "variables";

const DealerContainer = ({ actions, partnerId, dealers, dealersLoaded, contactModes, params, setIsDirty }) => {
  const { t } = useTranslation();
  const synchronizationInProgress = useReactiveVar(synchronizationInProgressVar);
  const [dealersList, setDealersList] = useState(dealers);
  const [cardExpanded, setExpanded] = useState(false);
  const [contactModeCardExpanded, setContactModeCardExpanded] = useState(false);
  const [contactInfoCardExpanded, setContactModeInfoExpanded] = useState(false);

  const onContactModeCardExpand = (_, expanded) => {
    if (contactModeCardExpanded !== expanded) setContactModeCardExpanded(expanded);
  };

  const onContactInfoCardExpand = (_, expanded) => {
    if (contactInfoCardExpanded !== expanded) setContactModeInfoExpanded(expanded);
  };

  useEffect(() => {
    if (cardExpanded && !dealersLoaded && partnerId !== null) {
      actions.loadDealers(partnerId);
      actions.loadContactModes();
    }
  }, [actions, cardExpanded, dealersLoaded, partnerId]);

  useEffect(() => {
    if (dealersLoaded) {
      setDealersList(dealers);
    }
  }, [dealersLoaded]); // eslint-disable-line react-hooks/exhaustive-deps

  const onExpand = expanded => {
    if (cardExpanded !== expanded) setExpanded(expanded);
  };

  return (
    <CollapseCard
      id="propertyCard"
      icon={DescriptionIcon}
      iconColor="primary"
      title={t("Partner.Dealers")}
      expanded={cardExpanded}
      onToggle={(_, expanded) => onExpand(!expanded)}
      defaultExpanded={synchronizationInProgress}
      toggleOnHeaderClick
    >
      {dealersList && dealersList.length > 0 && (
        <Grid container spacing={2}>
          {dealersList
            .filter(x => x.visibleContacts)
            .map((_item, _idx) => {
              return (
                <DealerListComponent
                  key={_idx}
                  dealer={_item}
                  contactModes={contactModes}
                  partnerId={partnerId}
                  contactModeCardExpanded={contactModeCardExpanded}
                  onContactModeCardExpand={onContactModeCardExpand}
                  onContactInfoCardExpand={onContactInfoCardExpand}
                  contactInfoCardExpanded={contactInfoCardExpanded}
                  setIsDirty={setIsDirty}
                  params={params}
                />
              );
            })}
        </Grid>
      )}
    </CollapseCard>
  );
};

DealerContainer.propTypes = {
  actions: PropTypes.object.isRequired,
  partnerId: PropTypes.number,
  dealers: PropTypes.array,
  dealersLoaded: PropTypes.bool.isRequired,
  contactModes: PropTypes.array.isRequired,
  params: PropTypes.object,
  setIsDirty: PropTypes.func
};

function mapStateToProps(state, ownProps) {
  const { content: dealers, loaded: dealersLoaded, loading: dealersLoading } = getDealers(state, ownProps.partnerId);
  const contactModes = getContactModes(state);

  return {
    dealers,
    dealersLoaded,
    dealersLoading,
    contactModes
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      {
        loadDealers,
        loadContactModes
      },
      dispatch
    ),
    dispatch
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(withParams(DealerContainer));
